// Store original slide templates
const SPECIAL_OFFERS_TEMPLATES = {};
let templatesStored = false;
let isInitializing = false;
let swiperInstance = null;

// Wait for Swiper library to load (non-fatal)
function waitForSwiper(timeout = 5000) {
  return new Promise((resolve) => {
    if (typeof Swiper !== 'undefined') {
      resolve(true);
      return;
    }

    const checkInterval = setInterval(() => {
      if (typeof Swiper !== 'undefined') {
        clearInterval(checkInterval);
        resolve(true);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(checkInterval);
      resolve(false); // silent fail
    }, timeout);
  });
}

// Helper function to wait for element to exist
function waitForElement(selector, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const element = document.querySelector(selector);
    if (element) {
      resolve(element);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const element = document.querySelector(selector);
      if (element) {
        obs.disconnect();
        resolve(element);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(() => {
      observer.disconnect();
      reject();
    }, timeout);
  });
}

// Main initialization function
async function initializeSpecialOffers() {
  if (isInitializing) return;
  isInitializing = true;
  
  try {
    // Stop if section or slider not on page
    if (!document.querySelector('[data-cart-special-section]')) return;
    if (!document.querySelector('[data-special-slider]')) return;

    // Wait for Swiper (silent)
    const swiperLoaded = await waitForSwiper();
    if (!swiperLoaded) return;

    // Wait for track element
    await waitForElement('[data-special-track]');
    
    // Store templates
    storeOriginalSlides();
    
    // Refresh offers
    await refreshSpecialOffers();
    
    // Initialize slider
    initSpecialOffersSlider();
    
    // Initialize close button
    initCloseButton();
    
    // Hide loader
    hideSpecialOffersLoading();
    
  } catch (_) {
    hideSpecialOffersLoading();
  } finally {
    isInitializing = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  showSpecialOffersLoading();
  initializeSpecialOffers();

  // Cart interaction listeners
  document.body.addEventListener('click', (e) => {
    if (
      e.target.matches('[data-remove-item], .cart__remove, .quantity__button') ||
      e.target.closest('[data-remove-item], .cart__remove, .quantity__button')
    ) {
      setTimeout(() => {
        showSpecialOffersLoading();
        refreshSpecialOffers().then(() => {
          initSpecialOffersSlider();
          initCloseButton();
          hideSpecialOffersLoading();
        });
      }, 600);
    }
  });

  document.addEventListener('cart:updated', () => {
    setTimeout(() => {
      showSpecialOffersLoading();
      refreshSpecialOffers().then(() => {
        initSpecialOffersSlider();
        initCloseButton();
        hideSpecialOffersLoading();
      });
    }, 200);
  });
  
  document.addEventListener('cart:refresh', () => {
    setTimeout(() => {
      showSpecialOffersLoading();
      refreshSpecialOffers().then(() => {
        initSpecialOffersSlider();
        initCloseButton();
        hideSpecialOffersLoading();
      });
    }, 200);
  });
  
  document.addEventListener('cart-drawer:updated', () => {
    showSpecialOffersLoading();
    refreshSpecialOffers().then(() => {
      initSpecialOffersSlider();
      initCloseButton();
      hideSpecialOffersLoading();
    });
  });

  // Add to cart handler
  document.addEventListener('click', async (e) => {
    const atcBtn = e.target.closest('.special-offer-atc-btn');
    if (!atcBtn || atcBtn.disabled || atcBtn.classList.contains('adding')) return;

    e.preventDefault();
    
    const variantId = atcBtn.dataset.variantId;
    const productTitle = atcBtn.dataset.productTitle;
    const btnText = atcBtn.querySelector('.atc-btn-text');
    const btnLoading = atcBtn.querySelector('.atc-btn-loading');

    try {
      atcBtn.classList.add('adding');
      btnText.style.display = 'none';
      btnLoading.style.display = 'inline-flex';

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
          }]
        })
      });

      if (!response.ok) throw new Error('Failed to add to cart');

      const data = await response.json();

      atcBtn.classList.remove('adding');
      atcBtn.classList.add('success');
      btnText.textContent = 'ADDED!';
      btnText.style.display = 'inline';
      btnLoading.style.display = 'none';

      refreshCartDrawer();

      setTimeout(() => {
        atcBtn.classList.remove('success');
        btnText.textContent = 'ADD TO CART';
      }, 1500);

    } catch (_) {
      atcBtn.classList.remove('adding');
      btnText.textContent = 'ADD TO CART';
      btnText.style.display = 'inline';
      btnLoading.style.display = 'none';
    }
  });
});

// Function to initialize close button
function initCloseButton() {
  const closeButton = document.querySelector('.cart-special-offers-close');
  const specialOffersSection = document.querySelector('[data-cart-special-section]');
  if (!closeButton || !specialOffersSection) return;
  
  const newCloseButton = closeButton.cloneNode(true);
  closeButton.parentNode.replaceChild(newCloseButton, closeButton);
  
  newCloseButton.addEventListener('click', function() {
    specialOffersSection.style.opacity = '0';
    specialOffersSection.style.transition = 'opacity 0.3s ease';
    
    setTimeout(function() {
      specialOffersSection.style.display = 'none';
    }, 300);
    
    sessionStorage.setItem('specialOffersClosed', 'true');
  });
  
  if (sessionStorage.getItem('specialOffersClosed') === 'true') {
    specialOffersSection.style.display = 'none';
  }
}

function showSpecialOffersLoading() {
  const specialSection = document.querySelector('[data-cart-special-section]');
  if (specialSection) specialSection.classList.add('loading');
}

function hideSpecialOffersLoading() {
  const specialSection = document.querySelector('[data-cart-special-section]');
  if (specialSection) specialSection.classList.remove('loading');
}

function storeOriginalSlides() {
  if (templatesStored && Object.keys(SPECIAL_OFFERS_TEMPLATES).length > 0) return;

  const slides = document.querySelectorAll('.special-offer-slide');
  if (!slides.length) return;

  slides.forEach(slide => {
    const productId = slide.dataset.productId;
    if (productId && !SPECIAL_OFFERS_TEMPLATES[productId]) {
      SPECIAL_OFFERS_TEMPLATES[productId] = slide.cloneNode(true);
    }
  });

  templatesStored = true;
}

function refreshCartDrawer() {
  showSpecialOffersLoading();
  
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      fetch('/cart?view=drawer')
        .then(res => res.text())
        .then(html => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.classList.remove('is-empty');
          if (cartDrawer) {
            const parser = new DOMParser();
            const newDoc = parser.parseFromString(html, 'text/html');
            const newDrawerContent = newDoc.querySelector('cart-drawer');
            if (newDrawerContent) cartDrawer.innerHTML = newDrawerContent.innerHTML;
          }

          setTimeout(() => {
            refreshSpecialOffers().then(() => {
              initSpecialOffersSlider();
              initCloseButton();
              hideSpecialOffersLoading();
            });
          }, 300);
        });

      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: cart }));
    })
    .catch(() => hideSpecialOffersLoading());
}

function initSpecialOffersSlider() {
  if (typeof Swiper === 'undefined') return;

  const slider = document.querySelector('[data-special-slider]');
  const track = document.querySelector('[data-special-track]');
  if (!slider || !track) return;

  const slides = Array.from(track.querySelectorAll('.special-offer-slide'));
  if (slides.length === 0) return;

  if (swiperInstance) {
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  }

  swiperInstance = new Swiper('[data-special-slider]', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    pagination: {
      el: '[data-special-dots]',
      clickable: true,
    },
    speed: 400,
    touchRatio: 1,
    touchAngle: 45,
    grabCursor: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    a11y: {
      enabled: true,
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
    },
    effect: 'slide',
  });
}

async function refreshSpecialOffers() {
  const specialSection = document.querySelector('[data-cart-special-section]');
  const track = document.querySelector('[data-special-track]');
  if (!specialSection || !track) return;

  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    if (cart.item_count === 0) {
      specialSection.style.display = 'none';
      return;
    }

    const cartProductIds = new Set(cart.items.map(item => item.product_id.toString()));
    track.innerHTML = '';

    Object.keys(SPECIAL_OFFERS_TEMPLATES).forEach(productId => {
      if (!cartProductIds.has(productId)) {
        const slideTemplate = SPECIAL_OFFERS_TEMPLATES[productId].cloneNode(true);
        track.appendChild(slideTemplate);
      }
    });

    const remainingSlides = track.querySelectorAll('.special-offer-slide');
    if (remainingSlides.length === 0) {
      specialSection.style.display = 'none';
    } else if (sessionStorage.getItem('specialOffersClosed') !== 'true') {
      specialSection.style.display = 'block';
      specialSection.style.opacity = '1';
    }

  } catch (_) {}
}






// Start Sample Product - Remove properties and variant option

(function () {
  // ✅ Configuration
  const EXCLUDED_PRODUCTS = ['/products/samples'];
  
  // ✅ Exact property names to remove from checkout
  const PROPERTIES_TO_REMOVE = [
    'Sample of tag',
    'Vendor',
    'Sample of tag: Metre'
  ];

  // ✅ Property class names to hide in cart UI
  const PROPERTY_CLASSES_TO_HIDE = [
    '.cart-item-total-metres',
    '.m-cart-item__option' // This is for "Sample of tag: Metre" and variant options
  ];

  // ✅ Check if product should be excluded
  function isExcludedProduct(cartItem) {
    const productLink = cartItem.querySelector('a[href*="/products/"]');
    if (productLink) {
      const href = productLink.getAttribute('href');
      return EXCLUDED_PRODUCTS.some(url => href.includes(url));
    }
    
    const productUrl = cartItem.dataset.productUrl || cartItem.dataset.url;
    if (productUrl) {
      return EXCLUDED_PRODUCTS.some(url => productUrl.includes(url));
    }
    
    return false;
  }

  // ✅ Hide excluded properties and variant options from display in cart
  function hideExcludedProperties(cartItem) {
    // Hide by specific class names
    PROPERTY_CLASSES_TO_HIDE.forEach(className => {
      const elements = cartItem.querySelectorAll(className);
      elements.forEach(el => {
        el.style.display = 'none';
      });
    });

    // Hide ALL variant options (Title, Size, Color options, etc.)
    const options = cartItem.querySelectorAll('.m-cart-item__option');
    options.forEach(el => {
      el.style.display = 'none';
    });

    // Hide the metre tag container if it exists
    const metreContainer = cartItem.querySelector('.item-tag-metre');
    if (metreContainer) {
      metreContainer.style.display = 'none';
    }
    
    // Hide the vendor container if it exists
    const vendorContainer = cartItem.querySelector('.cart-item-vendor');
    if (vendorContainer) {
      vendorContainer.style.display = 'none';
    }
  }

  // ✅ Get current cart and filter properties
  async function removePropertiesFromCart(line) {
    try {
      // First, get the current cart to see existing properties
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Find the item by line number (line is 1-indexed)
      const item = cart.items[line - 1];
      if (!item) {
        console.log('❌ Item not found at line', line);
        return;
      }

      // Get current properties
      const currentProperties = item.properties || {};
      
      console.log('📋 Current properties for line', line, ':', currentProperties);
      
      // Create new properties object, keeping only the ones we want
      const newProperties = {};
      Object.keys(currentProperties).forEach(key => {
        // Check if this exact property should be removed
        const shouldRemove = PROPERTIES_TO_REMOVE.some(prop => key === prop);
        
        if (!shouldRemove) {
          newProperties[key] = currentProperties[key];
          console.log('✅ Keeping property:', key, '=', currentProperties[key]);
        } else {
          console.log('❌ Removing property:', key);
        }
      });

      console.log('📦 New properties to save:', newProperties);

      // Update cart with filtered properties
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: item.quantity,
          properties: newProperties
        })
      });
      
      const updatedCart = await response.json();
      console.log(`✅ Updated cart for line ${line}`);
      console.log('Final properties at checkout:', updatedCart.items[line - 1].properties);
      return updatedCart;
    } catch (error) {
      console.error(`❌ Error filtering properties:`, error);
      return null;
    }
  }


  // ✅ Process all cart items
  async function processCartItems() {
    console.log('🔄 Processing cart items...');
    const cartItems = document.querySelectorAll('.m-cart-item');
    
    for (const cartItem of cartItems) {
      if (isExcludedProduct(cartItem)) {
        console.log('🎯 Found samples product, processing...');
        
        // Hide properties and variant options in UI immediately
        hideExcludedProperties(cartItem);
        
        // Remove from cart/checkout
        const qtyInput = cartItem.querySelector('.m-quantity__input[data-index]');
        if (qtyInput) {
          const line = parseInt(qtyInput.dataset.index, 10);
          if (line) {
            await removePropertiesFromCart(line);
            // Wait before processing next item
            await new Promise(resolve => setTimeout(resolve, 400));
          }
        }
      }
    }
  }

  // ✅ Observe cart changes
  let observer;
  function initObserver() {
    if (observer) observer.disconnect();

    observer = new MutationObserver(() => {
      setTimeout(processCartItems, 500);
    });

    ['.m-cart__items', '.m-cart-drawer__items', '.m-cart-drawer-item__variant'].forEach(sel => {
      const el = document.querySelector(sel);
      if (el) observer.observe(el, { childList: true, subtree: true });
    });
  }

  // ✅ Initialize
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(processCartItems, 800);
    initObserver();
  });

  document.addEventListener('cart:updated', () => {
    setTimeout(processCartItems, 500);
  });
  
  document.addEventListener('shopify:cart:update', () => {
    setTimeout(processCartItems, 500);
  });

  // ✅ Also run when cart drawer opens
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-drawer-toggle], .m-cart-drawer-toggle')) {
      setTimeout(processCartItems, 600);
    }
  });

  // ✅ DEBUG: Check cart properties
  window.debugSamplesCart = async function() {
    const cart = await fetch('/cart.js').then(r => r.json());
    console.log('🛒 Full cart:', cart);
    cart.items.forEach((item, index) => {
      console.log(`Item ${index + 1}:`, item.product_title);
      console.log('Variant title:', item.variant_title);
      console.log('Properties:', item.properties);
    });
  };
  
  // console.log('💡 Run debugSamplesCart() in console to see current cart properties');
})();

 // End Sample Product - Remove properties and variant option
